module.exports = __webpack_public_path__ + "static/media/flower6.999e6e20.png";